module.exports = __webpack_public_path__ + "static/media/card-dontoi-buy.233c644a.png";